/*@ngInject*/
const UIGridPagingDirective = function (coreConstant, localization) {

    let linkFunction = function ($scope) {

        let buttonWidth = 65,
            pageWidth = 35,
            summaryLength = 250,
            i;

        $scope.pages = [];
        $scope.$ctrl.maxVisiblePages = 10;
        $scope.startRecord = 1;
        $scope.endRecord = $scope.$ctrl.requestParams.pageSize;
        $scope.selectedPage = Math.ceil($scope.$ctrl.requestParams.startIndex / $scope.$ctrl.requestParams.pageSize) + 1;
        $scope.recordCountText = $scope.$ctrl.recordCountText;
        $scope.recordsCountText = $scope.$ctrl.recordsCountText;
        $scope.isTask = $scope.$ctrl.isTask;

        for (i = 1; i < $scope.$ctrl.maxVisiblePages + 1; i++) {
            $scope.pages.push({number: i});
        }

        if (_.isNil($scope.recordCountText) && _.isNil($scope.recordsCountText)) {
            localization.getTranslationByKey('homePage.grid').then(function (translation) {
                $scope.recordCountText = $scope.isTask ? translation.taskCount : translation.submissionCount;
                $scope.recordsCountText = $scope.isTask ? translation.tasksCount : translation.submissionsCount;
                if ($scope.$ctrl.isGenericItem) {
                    $scope.recordCountText = translation.itemCount;
                    $scope.recordsCountText = translation.itemsCount;
                }
            });
        }

        let totalWidth = 2 * buttonWidth + $scope.pages.length * pageWidth + summaryLength;
        $scope.totalWidth = {'width': totalWidth + 'px'};

        $scope.numberClick = function (index) {
            let page = $scope.pages[index];
            if ($scope.selectedPage === page.number) {
                return;
            }

            //making sure that an empty page cannot be selected
            while ((page.number - 1) * $scope.$ctrl.requestParams.pageSize > $scope.$ctrl.totalRecords) {
                page.number--;
            }
            $scope.selectedPage = page.number;


            $scope.notify();
        };

        $scope.getMaxNumPages = function () {
            return Math.ceil($scope.$ctrl.totalRecords / $scope.$ctrl.requestParams.pageSize);
        };

        $scope.changePage = function (direction) {
            let length = $scope.getMaxNumPages();
            if ($scope.selectedPage === length && direction === 1) {
                return;
            }

            if ($scope.selectedPage === 1 && direction === -1) {
                return;
            }

            $scope.selectedPage += direction;

            //define upper limit
            if ($scope.selectedPage > length) {
                $scope.selectedPage = length;
            }

            //define lower limit
            if ($scope.selectedPage < 1) {
                $scope.selectedPage = 1;
            }
            $scope.notify();
        };

        $scope.notify = function () {
            let requestParams = $scope.$ctrl.requestParams;
            requestParams.startIndex = ($scope.selectedPage - 1) * requestParams.pageSize;
            $scope.$emit(coreConstant.event.DATAGRID_ON_RESET_HEADERS, $scope.$ctrl.requestParams);
            $scope.startRecord = ($scope.selectedPage - 1) * (requestParams.pageSize) + 1;
            $scope.calculateVisiblePages();
        };

        $scope.calculateVisiblePages = function () {
            //updating visible pages in the pager
            let numOfGroups = Math.ceil($scope.$ctrl.totalRecords / $scope.$ctrl.requestParams.pageSize),
                lower = 0,
                upper = 0,
                j;
            for (i = 0; i < numOfGroups; i++) {
                lower = i * $scope.$ctrl.maxVisiblePages;
                upper = i * $scope.$ctrl.maxVisiblePages + $scope.$ctrl.maxVisiblePages;
                if ($scope.selectedPage > lower && $scope.selectedPage <= upper) {
                    $scope.pages = [];
                    for (j = lower + 1; j < upper + 1 && j <= numOfGroups; j++) {
                        $scope.pages.push({number: j});
                    }
                    break;
                }
            }
            $scope.endRecord = $scope.selectedPage * $scope.$ctrl.requestParams.pageSize;
            //this is the case that the last page is not full
            if ($scope.endRecord > $scope.$ctrl.totalRecords) {
                $scope.endRecord = $scope.$ctrl.totalRecords;
            }
        };

        $scope.getRecordCountText = function () {
            let message = '';
            if ($scope.endRecord > 1) {
                message = $scope.recordsCountText;
            } else {
                message = $scope.recordCountText;
            }
            message = _.replace(message, 'startIndex', $scope.startRecord);
            message = _.replace(message, 'endIndex', $scope.endRecord);
            message = _.replace(message, 'total', $scope.$ctrl.totalRecords);
            return message;
        };

        $scope.$on(coreConstant.event.RESET_GRID_PAGING, function () {
            $scope.$ctrl.requestParams.startIndex = 0;
            $scope.startRecord = 1;
            $scope.selectedPage = 1;
            $scope.endRecord = $scope.$ctrl.requestParams.pageSize;
            $scope.notify();
        });

        $scope.$on(coreConstant.event.RECALCULATE_GRID_PAGING, function () {
            $scope.calculateVisiblePages();
        });

        $scope.calculateVisiblePages();
    };

    return {
        restrict: 'A',
        link: linkFunction,
        templateUrl: '/ui/grid/gridPaging/gridPaging.tpl.html'
    };
};

angular.module('umCore')
    .directive('uiGridPaging', UIGridPagingDirective);
